import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: string;
  title: string;
  author: string;
  cover: string;
  status: string;
  rating: number;
  views: number;
  categories: string[];
  updatedAt: string;
}

export default function ComicCard({ id, title, author, cover, status, rating, views, categories, updatedAt }: ComicCardProps) {
  const categoryMap: Record<string, string> = {
    hanman: '韩漫',
    riman: '日漫',
    guoman: '国漫',
    wanjie: '完结',
  };

  return (
    <Link to={`/comic/${id}`} className="group block cursor-pointer" data-product-shop="true">
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] bg-background-200">
        <img
          src={cover}
          alt={`虫虫漫画 - ${title}`}
          title={`虫虫漫画 - ${title} 免费在线看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <div className="absolute top-2 left-2">
          <span className={`px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
            status === '完结' ? 'bg-accent-500 text-background-50' : 'bg-primary-500 text-background-50'
          }`}>
            {status}
          </span>
        </div>
        {rating >= 9.5 && (
          <div className="absolute top-2 right-2">
            <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-accent-500 text-background-50 whitespace-nowrap">
              热门
            </span>
          </div>
        )}
      </div>
      <div className="mt-3">
        <h3 className="text-sm font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors">
          {title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1 whitespace-nowrap">{author}</p>
        <div className="flex items-center gap-2 mt-2 flex-wrap">
          {categories.slice(0, 2).map(cat => (
            <span key={cat} className="text-xs px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-700 whitespace-nowrap">
              {categoryMap[cat] || cat}
            </span>
          ))}
          <span className="text-xs text-foreground-400 whitespace-nowrap">
            <i className="ri-star-fill text-accent-500 text-xs mr-0.5"></i>
            {rating}
          </span>
        </div>
      </div>
    </Link>
  );
}